import type { ModuleId } from './modules';

/**
 * The soft-background / foreground pair each module is drawn with.
 *
 * It lives next to the registry rather than in a page because four screens need
 * it now — the drawer, the Apps tile on Home, the search results and the Apps
 * page — and a page is the wrong owner for a value the shell reads.
 */
export const MODULE_ICON_CLASSES: Record<ModuleId, string> = {
  folders: 'bg-module-folders-soft text-module-folders',
  calendar: 'bg-module-calendar-soft text-module-calendar',
  trips: 'bg-module-calendar-soft text-module-calendar',
  sheets: 'bg-module-sheets-soft text-module-sheets',
  notes: 'bg-module-notes-soft text-module-notes',
  cashflow: 'bg-module-cashflow-soft text-module-cashflow',
  investments: 'bg-module-investments-soft text-module-investments',
  forms: 'bg-module-forms-soft text-module-forms',
  stock: 'bg-module-stock-soft text-module-stock',
  payroll: 'bg-module-payroll-soft text-module-payroll',
  calculators: 'bg-module-calculators-soft text-module-calculators',
  numadmin: 'bg-module-numadmin-soft text-module-numadmin',
  admin: 'bg-module-admin-soft text-module-admin',
};
